import { styled } from "styled-components";

export const ProductContainer = styled.div`
  padding: 16px;
  border: 1px solid #ccc;
`;
